import InternationalServiceLinkMcom from './InternationalServiceLink.mcom';
import InternationalServiceLinkBcom from './InternationalServiceLink.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? InternationalServiceLinkBcom : InternationalServiceLinkMcom;
